module.exports = __webpack_public_path__ + "img/usersIcon.693b0394.svg";